import { useSelector, useDispatch } from 'react-redux'
import { actions as userActions } from '../user/user.reducer'

const useUser = () => {
    const dispatch = useDispatch()

    return {
        user: useSelector(({ firebase: { profile } }) => ({
            ...profile,
        })),
        error: useSelector(({ user: { error } }) => error),
        detail: useSelector((state) => state.firebase.auth),
        logout: () => dispatch(userActions.logout()),
    }
}

export default useUser
